import cn from 'classnames';
import React, {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {AppButton} from '../../../../../components/Button';
import {FirmwareUpdateBlueIcon} from '../../../../../components/Icons';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import storageService from '../../../../../services/storage/storageService';
import {setWasShownLeviaGetStartedNotification} from '../../../../../state/ducks/global';
import {selectLeviaRelatedTargetSerialNumber} from '../../../../../state/selectors/iotDevice';
import {dispatch} from '../../../../../state/store';

interface IProps {
    onClick: () => void;
}

const LeviaGetStartedNotification: FC<IProps> = (props) => {
    const {onClick} = props || {};
    const localizedStrings = getLocalizedStrings();
    const notificationText = localizedStrings[localizationKeys.LEVIA_TOAST_NOTIFICATION_DESCRIPTION_GET_STARTED];
    const serialNumber = useSelector(selectLeviaRelatedTargetSerialNumber);

    useEffect(() => {
        storageService.setLeviaPopupsDataToLocalStorageBySerialNumber({
            serialNumber,
            wasShownGetStartedNotification: true,
        });
    }, [serialNumber]);

    const handleGetStartedClick = () => {
        onClick();

        dispatch(setWasShownLeviaGetStartedNotification(true));
    };

    return (
        <div className='flex items-center gap-4'>
            <FirmwareUpdateBlueIcon />
            <div className='w-full flex-1'>
                <p className='text-16 font-bold leading-15 tracking-02'>
                    {localizedStrings[localizationKeys.LEVIA_TOAST_NOTIFICATION_TITLE_GET_STARTED]}
                </p>
                <span className={cn({'pr-1': notificationText})}>{notificationText}</span>
                <AppButton tertiary onClick={handleGetStartedClick} className='inline font-bold'>
                    {localizedStrings[localizationKeys.LEVIA_TOAST_NOTIFICATION_DESCRIPTION_GET_STARTED_CTA]}
                </AppButton>
            </div>
        </div>
    );
};

export default LeviaGetStartedNotification;
